// extracted by mini-css-extract-plugin
export default {"root":"zNVRO","warning":"_3TZ1U"};